// Shuttle next-stop rules for the BIAL route.
// Logistics Park -> Level 0 visits T1-Departure and skips Manipal Hospital.
// Level 0 -> Logistics Park visits Manipal Hospital and skips T1-Departure.
// Once the shuttle is more than this far past a stop, that stop is no longer "next".

export const NEXT_STOP_HANDOFF_METERS = 50;

export function normalizeStopName(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function isT1DepartureStop(stop) {
  const name = normalizeStopName(stop?.name ?? stop);
  return name.includes("t1-departure") || name.includes("t1 departure");
}

export function isManipalHospitalStop(stop) {
  const name = normalizeStopName(stop?.name ?? stop);
  return name.includes("manipal hospital");
}

export function isStopVisibleForDirection(stop, pathDirection) {
  if (isManipalHospitalStop(stop)) {
    return pathDirection === "dest_to_source";
  }
  if (isT1DepartureStop(stop)) {
    return pathDirection === "source_to_dest";
  }
  return true;
}

export function filterStopsForDirection(stops, pathDirection) {
  return (stops || []).filter((stop) =>
    isStopVisibleForDirection(stop, pathDirection),
  );
}

/**
 * Choose the next stop by route order.
 * A stop already behind the vehicle stays only while the shuttle is still
 * within handoffMeters of it. A visited stop is dropped once the shuttle
 * has moved farther than that.
 */
export function selectNextStopByRouteOrder({
  stops,
  currentIndex,
  isInbound,
  visitedStopIds = [],
  handoffMeters = NEXT_STOP_HANDOFF_METERS,
}) {
  const visited = new Set(visitedStopIds);

  const candidates = (stops || []).filter((stop) => {
    if (stop?.routeIndex == null || stop.routeIndex < 0) return false;

    const distance = Number(stop.distance);
    const leftVisitedStop =
      visited.has(stop.stopId) && distance > handoffMeters;
    if (leftVisitedStop) return false;

    const isAhead = isInbound
      ? stop.routeIndex <= currentIndex
      : stop.routeIndex >= currentIndex;
    const stillBesideStop = distance <= handoffMeters;
    return isAhead || stillBesideStop;
  });

  candidates.sort((a, b) =>
    isInbound ? b.routeIndex - a.routeIndex : a.routeIndex - b.routeIndex,
  );

  return candidates[0] || null;
}
